import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import {connect} from 'react-redux';
import Const from 'constants';
import ExclusionInfo from './atoms/exclusion-info';
import PlayerExclusionSwitcher from './player-exclusion-switcher';

class PlayerExclusionState extends Component {
    isExcludedMode() {
        const {activeMode} = this.props;
        return Const.EXCLUDED_MODE === activeMode;
    }

    getTooltipByMode() {
        const {players, playerId} = this.props;
        const player = players.getPlayer(playerId);
        const tooltip = [];
        if (player.isExcludedBy(Const.EXCLUDED_BY_ORDER_RANGE)) {
            tooltip.push(' Order');
        }
        if (player.isExcludedBy(Const.EXCLUDED_BY_CONFIRMED_RANGE)) {
            tooltip.push(' Confirmed');
        }
        if (player.isExcludedBy(Const.EXCLUDED_BY_LINE_GROUPS_RANGE)) {
            tooltip.push(' Line Grouping');
        }
        if (player.isExcludedByPoints(Const.FLEX_MODE)) {
            tooltip.push(' Fantasy Points');
        }
        if (player.isExcludedBySalary(Const.FLEX_MODE)) {
            tooltip.push(' Salary');
        }
        return tooltip;
    }

    render() {
        const {playerId} = this.props;

        if (this.isExcludedMode()) {
            const tooltip = this.getTooltipByMode();
            if (!isEmpty(tooltip)) {
                return <ExclusionInfo tooltip={tooltip} />;
            }
        }

        return <PlayerExclusionSwitcher playerId={playerId} />;
    }
}

function mapStatesToProps(state) {
    const {playersData} = state;
    return {
        players: playersData.players,
    };
}

export default connect(mapStatesToProps)(PlayerExclusionState);
